var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"f-circle",class:'f-circle-'+_vm.scores[_vm.pri-1]},[_vm._v(_vm._s(_vm.scoresChar[_vm.pri-1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }